export default __webpack_public_path__ + "static/media/undraw_blank_canvas_3rbb.48d30d7c.svg";